export default {
	NewConfigSend: 'Nouvelle configuration sauvegardée',
	Close: 'Fermer',
};
